import { render, staticRenderFns } from "./PalvelusopimusKayttajatili.vue?vue&type=template&id=22e3833a&scoped=true&"
import script from "./PalvelusopimusKayttajatili.vue?vue&type=script&lang=js&"
export * from "./PalvelusopimusKayttajatili.vue?vue&type=script&lang=js&"
import style0 from "./PalvelusopimusKayttajatili.vue?vue&type=style&index=0&id=22e3833a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e3833a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VDataTable,VDivider,VRadio,VRadioGroup,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e3833a')) {
      api.createRecord('22e3833a', component.options)
    } else {
      api.reload('22e3833a', component.options)
    }
    module.hot.accept("./PalvelusopimusKayttajatili.vue?vue&type=template&id=22e3833a&scoped=true&", function () {
      api.rerender('22e3833a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PalvelusopimusKayttajatili.vue"
export default component.exports